var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _vm.IsAdmin()
                        ? _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.showAddLeaveTypesModal },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" New Leave Types "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger", size: "sm" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredLeaveTypes,
                          fields: _vm.leavetypes_fields,
                        },
                        on: { filtered: _vm.onFiltered },
                        scopedSlots: _vm._u([
                          {
                            key: "head(title)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("title")
                                          },
                                        },
                                      },
                                      [_vm._v("Title")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Title",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.title,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "title", $$v)
                                        },
                                        expression: "filters.title",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(abbreviation)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "abbreviation"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Abbreviation")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Abbreviation",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.abbreviation,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "abbreviation",
                                            $$v
                                          )
                                        },
                                        expression: "filters.abbreviation",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(color)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("color")
                                          },
                                        },
                                      },
                                      [_vm._v("Color")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Color",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.color,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "color", $$v)
                                        },
                                        expression: "filters.color",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(status)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("status")
                                          },
                                        },
                                      },
                                      [_vm._v("Status")]
                                    ),
                                    _c("b-form-select", {
                                      attrs: {
                                        options:
                                          _vm.statusOptionsWithPlaceholder,
                                        size: "sm",
                                      },
                                      on: { change: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.status,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "status", $$v)
                                        },
                                        expression: "filters.status",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant:
                                        _vm.statusVariants[data.item.status],
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(data.item.status) + " ")]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: { disabled: !_vm.IsAdmin() },
                                        on: {
                                          click: function ($event) {
                                            return _vm.leaveAction(
                                              "ACTIVATE",
                                              data.item,
                                              data.item.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "CheckIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Activate")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: { disabled: !_vm.IsAdmin() },
                                        on: {
                                          click: function ($event) {
                                            return _vm.leaveAction(
                                              "DEACTIVATE",
                                              data.item,
                                              data.item.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "XIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Deactivate")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showViewLeaveTypesModal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("View")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: { disabled: !_vm.IsAdmin() },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showEditLeaveTypesModal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center mb-1" },
                        [
                          _vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mb-1",
                                },
                                [
                                  _c("b-spinner", {
                                    staticStyle: {
                                      width: "3rem",
                                      height: "3rem",
                                    },
                                    attrs: {
                                      variant: "success",
                                      label: "Spinning",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalAddLeaveTypes",
                  attrs: {
                    id: "modal-add-leave-types",
                    title: "Add New Leave Types",
                    "hide-footer": "",
                    centered: "",
                  },
                  on: { hide: _vm.resetForm },
                },
                [
                  _c("validation-observer", {
                    ref: "addLeaveTypesForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var validate = ref.validate
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    validate().then(function (success) {
                                      return success && _vm.addNewLeaveTypes()
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Title*",
                                      "label-for": "title",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Title",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "title" },
                                                  model: {
                                                    value:
                                                      _vm.newLeaveTypes.title,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newLeaveTypes,
                                                        "title",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newLeaveTypes.title",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Abbreviation*",
                                      "label-for": "abbreviation",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Abbreviation",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "abbreviation" },
                                                  model: {
                                                    value:
                                                      _vm.newLeaveTypes
                                                        .abbreviation,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newLeaveTypes,
                                                        "abbreviation",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newLeaveTypes.abbreviation",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Color*",
                                      "label-for": "color",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Color",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "color",
                                                    options: _vm.colorOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newLeaveTypes.color,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newLeaveTypes,
                                                        "color",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newLeaveTypes.color",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Balance*",
                                      "label-for": "balance",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Balance",
                                        rules: "required|numeric",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "balance",
                                                    type: "number",
                                                    min: "1",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newLeaveTypes.balance,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newLeaveTypes,
                                                        "balance",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newLeaveTypes.balance",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Status*",
                                      "label-for": "status",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Status",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "status",
                                                    options: _vm.statusOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newLeaveTypes.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newLeaveTypes,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newLeaveTypes.status",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      disabled: invalid,
                                    },
                                  },
                                  [_vm._v(" Add Leave Types ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalEditLeaveTypes",
                  attrs: {
                    id: "modal-edit-leave-types",
                    title: "Edit Leave Types",
                    "hide-footer": "",
                    centered: "",
                  },
                },
                [
                  _c("validation-observer", {
                    ref: "editLeaveTypesForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var validate = ref.validate
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    validate().then(function (success) {
                                      return success && _vm.updateLeaveTypes()
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Title",
                                      "label-for": "editTitle",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Title",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "editTitle" },
                                                  model: {
                                                    value:
                                                      _vm.editLeaveTypes.title,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editLeaveTypes,
                                                        "title",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editLeaveTypes.title",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Abbreviation",
                                      "label-for": "editAbbreviation",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Abbreviation",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "abbreviation" },
                                                  model: {
                                                    value:
                                                      _vm.editLeaveTypes
                                                        .abbreviation,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editLeaveTypes,
                                                        "abbreviation",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editLeaveTypes.abbreviation",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Color",
                                      "label-for": "editColor",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Color",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "color",
                                                    options: _vm.colorOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editLeaveTypes.color,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editLeaveTypes,
                                                        "color",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editLeaveTypes.color",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Balance",
                                      "label-for": "editBalance",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Balance",
                                        rules: "required|numeric",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "balance",
                                                    type: "number",
                                                    min: "1",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editLeaveTypes
                                                        .balance,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editLeaveTypes,
                                                        "balance",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editLeaveTypes.balance",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Status",
                                      "label-for": "editStatus",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Status",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "editStatus",
                                                    options: _vm.statusOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editLeaveTypes.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editLeaveTypes,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editLeaveTypes.status",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      disabled: invalid,
                                    },
                                  },
                                  [_vm._v(" Save Changes ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalViewLeaveTypes",
                  attrs: {
                    id: "modal-view-gps",
                    title: "View Leave Types",
                    "hide-footer": "",
                    centered: "",
                  },
                },
                [
                  _c(
                    "b-form",
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Title", "label-for": "viewTitle" } },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewTitle", readonly: "" },
                            model: {
                              value: _vm.viewLeaveTypes.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewLeaveTypes, "title", $$v)
                              },
                              expression: "viewLeaveTypes.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Abbreviation",
                            "label-for": "viewAbbreviation",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewAbbreviation", readonly: "" },
                            model: {
                              value: _vm.viewLeaveTypes.abbreviation,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.viewLeaveTypes,
                                  "abbreviation",
                                  $$v
                                )
                              },
                              expression: "viewLeaveTypes.abbreviation",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        { attrs: { label: "Color", "label-for": "viewColor" } },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewColor", readonly: "" },
                            model: {
                              value: _vm.viewLeaveTypes.color,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewLeaveTypes, "color", $$v)
                              },
                              expression: "viewLeaveTypes.color",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Balance",
                            "label-for": "viewBalance",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewBalance", readonly: "" },
                            model: {
                              value: _vm.viewLeaveTypes.balance,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewLeaveTypes, "balance", $$v)
                              },
                              expression: "viewLeaveTypes.balance",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: { label: "Status", "label-for": "viewStatus" },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewStatus", readonly: "" },
                            model: {
                              value: _vm.viewLeaveTypes.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewLeaveTypes, "status", $$v)
                              },
                              expression: "viewLeaveTypes.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }